import type { CreateCompanyInput, UpdateCompanyInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type {
  CompaniesAdminParams,
  CompanyAdminRow,
  PaginatedCompanies
} from '../models/company-admin'

export async function getCompaniesAdmin(params: CompaniesAdminParams): Promise<PaginatedCompanies> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedCompanies>(
    `${API.companies.root}${qs ? `?${qs}` : ''}`
  )
  return data
}

/** Los payloads son los MISMOS schemas Zod que valida el backend. */
export async function createCompany(payload: CreateCompanyInput): Promise<CompanyAdminRow> {
  const { data } = await axiosPrivate.post<CompanyAdminRow>(API.companies.root, payload)
  return data
}

export async function updateCompany(
  id: string,
  payload: UpdateCompanyInput
): Promise<CompanyAdminRow> {
  const { data } = await axiosPrivate.patch<CompanyAdminRow>(API.companies.byId(id), payload)
  return data
}

export async function deleteCompany(id: string) {
  const { data } = await axiosPrivate.delete(API.companies.byId(id))
  return data
}
